<template>
  <PackageAuth>
    <template #authorized-content>
      <div class="q-pa-xs">
        <div class="text-h6" :class="$q.dark.mode ? '' : 'text-primary'">
          Accumulation and Distribution
          <HelpComponent :helpUrl="'https://youtu.be/KuOwR9ZAZMc'" />
          <div class="text-caption text-bold q-pa-xs">
            As of : {{ store.state.market.asOf }}
          </div>
        </div>

        <q-card flat bordered class="row q-px-xs">
          <div
            :class="isMainChart ? 'col-12' : 'col-12 col-md-6'"
            class="q-pa-xs"
          >
            <div
              class="text-subtitle1 text-weight-medium"
              :class="$q.dark.mode ? '' : 'text-secondary'"
            >
              Accumulation
            </div>
            <q-separator />
            <div class="justify-left q-gutter-xs q-py-xs">
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="OneDay"
                label="1 D"
                color="red"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Day</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="TwoDay"
                label="2 D"
                color="deep-orange"
                keep-color
              >
                <q-tooltip class="bg-primary">2 Day</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="OneWeek"
                label="1 W"
                color="brown"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Week</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="TwoWeek"
                label="2 W"
                color="indigo"
                keep-color
              >
                <q-tooltip class="bg-primary">2 Week</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="OneMonth"
                label="1 M"
                color="blue"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="ThreeMonth"
                label="3 M"
                color="cyan"
                keep-color
              >
                <q-tooltip class="bg-primary">3 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="SixMonth"
                label="6 M"
                color="teal"
                keep-color
              >
                <q-tooltip class="bg-primary">6 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodAccumulation"
                size="xs"
                val="OneYear"
                label="1 Y"
                color="green"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Year</q-tooltip>
              </q-radio>
            </div>
            <q-table
              flat
              dense
              bordered
              :class="
                $q.dark.mode
                  ? 'table-sticky-header-column-dark'
                  : 'table-sticky-header-column-grey'
              "
              :rows="computedaccumulationData"
              :columns="accumulationColumns"
              separator="cell"
              binary-state-sort
              :pagination="pagination"
              :filter="filterSymbolAccumulation"
              :filter-method="filterAccumulationData"
            >
              <template v-if="!symbol" v-slot:top-left>
                <q-input
                  bordered
                  dense
                  debounce="300"
                  v-model="filterSymbolAccumulation"
                  placeholder="Filter Symbols"
                  class="q-mr-md ellipsis"
                  style="width: 100px"
                />

                <q-select
                  outline
                  v-model="selectedSectorAccumulation"
                  :options="optionSectors"
                  dense
                  label="Choose sector"
                  single
                  input-debounce="0"
                  option-label="name"
                  option-value="symbol"
                  class="ellipsis"
                  :menu-absolute="true"
                />
                <q-select
                  outline
                  v-model="selectedQuantityAccumulation"
                  :options="['All', 1, 3, 5, 10]"
                  dense
                  label="Choose Float Qnty %"
                  single
                  input-debounce="0"
                  class="ellipsis q-pl-sm"
                  :menu-absolute="true"
                  style="width: 135px"
                >
                  <q-tooltip> Float Qnty % greater than </q-tooltip>
                </q-select>
              </template>
              <template v-slot:top-right>
                <q-select
                  :menu-absolute="true"
                  bordered
                  class="ellipsis"
                  v-model.lazy="selectedBrokerAccumulation"
                  single
                  dense
                  clearable
                  use-input
                  input-debounce="0"
                  :options="options"
                  option-value="broker_no"
                  option-label="broker_name"
                  emit-value
                  stack-label
                  map-options
                  label="Select broker Buyer"
                  filter
                  @filter="filterFn"
                >
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps">
                      <q-item-section avatar>
                        <q-item-label class="text-bold">{{
                          scope.opt.broker_no
                        }}</q-item-label>
                      </q-item-section>
                      <q-item-section>
                        <q-item-label>
                          <div class="row">
                            {{ scope.opt.broker_name }}
                          </div>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>

                <q-checkbox
                  dense
                  class="q-pl-sm ellipsis"
                  v-model="mySignalsAccumulation"
                  color="blue-5"
                  keep-color
                  label="My Signals"
                >
                  <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
                </q-checkbox>
              </template>
              <template v-slot:body-cell-symbol="props">
                <q-td :props="props">
                  <q-item
                    dense
                    clickable
                    :to="
                      !symbol && !isMainChart
                        ? {
                            path: '/stock-profile',
                            query: { symbol: props.value },
                          }
                        : ''
                    "
                    @click="onClickSymbolEmit(props.value)"
                  >
                    <div class="col">
                      {{ props.value }}
                      <q-tooltip>{{
                        allStocks.find((stock) => stock.symbol == props.value)
                          ?.name
                      }}</q-tooltip>
                    </div>
                  </q-item>
                </q-td>
              </template>
              <template v-slot:body-cell-buyer="props">
                <q-td :props="props">
                  <div class="col">
                    {{ props.value }}
                    <q-tooltip>{{
                      brokerLists.find(
                        (broker) => broker.broker_no === props.value
                      )?.broker_name
                    }}</q-tooltip>
                  </div>
                </q-td>
              </template>
              <template v-slot:body-cell-qnty_percentage="props">
                <q-td :props="props">
                  <q-linear-progress
                    size="24px"
                    stripe
                    rounded
                    :value="props.value / 100"
                    color="secondary"
                  >
                    <div class="absolute-full flex flex-center">
                      <q-badge
                        color="white"
                        text-color="secondary"
                        :label="`${props.row.qnty_percentage?.toFixed(2)} %`"
                      />
                    </div>
                  </q-linear-progress>
                </q-td>
              </template>
            </q-table>
          </div>

          <div
            :class="isMainChart ? 'col-12' : 'col-12 col-md-6'"
            class="q-pa-xs"
          >
            <div
              class="text-subtitle1 text-weight-medium"
              :class="$q.dark.mode ? '' : 'text-secondary'"
            >
              Distribution
            </div>
            <q-separator />
            <div class="justify-left q-gutter-xs q-py-xs">
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="OneDay"
                label="1 D"
                color="red"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Day</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="TwoDay"
                label="2 D"
                color="deep-orange"
                keep-color
              >
                <q-tooltip class="bg-primary">2 Day</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="OneWeek"
                label="1 W"
                color="brown"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Week</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="TwoWeek"
                label="2 W"
                color="indigo"
                keep-color
              >
                <q-tooltip class="bg-primary">2 Week</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="OneMonth"
                label="1 M"
                color="blue"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="ThreeMonth"
                label="3 M"
                color="cyan"
                keep-color
              >
                <q-tooltip class="bg-primary">3 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="SixMonth"
                label="6 M"
                color="teal"
                keep-color
              >
                <q-tooltip class="bg-primary">6 Month</q-tooltip>
              </q-radio>
              <q-radio
                v-model="timePeriodDistribution"
                size="xs"
                val="OneYear"
                label="1 Y"
                color="green"
                keep-color
              >
                <q-tooltip class="bg-primary">1 Year</q-tooltip>
              </q-radio>
            </div>
            <q-table
              flat
              dense
              bordered
              :class="
                $q.dark.mode
                  ? 'table-sticky-header-column-dark'
                  : 'table-sticky-header-column-grey'
              "
              :rows="computeddistributionData"
              :columns="distributionColumns"
              separator="cell"
              binary-state-sort
              :pagination="pagination"
              :filter="filterSymbolDistributation"
              :filter-method="filterDistributationData"
            >
              <template v-if="!symbol" v-slot:top-left>
                <q-input
                  bordered
                  dense
                  debounce="300"
                  v-model="filterSymbolDistributation"
                  placeholder="Filter Symbols"
                  class="q-mr-md ellipsis"
                  style="width: 100px"
                />

                <q-select
                  outline
                  v-model="selectedSectorDistribution"
                  :options="optionSectors"
                  dense
                  label="Choose sector"
                  single
                  input-debounce="0"
                  option-label="name"
                  option-value="symbol"
                  class="ellipsis"
                  :menu-absolute="true"
                />

                <q-select
                  outline
                  v-model="selectedQuantityDistribution"
                  :options="['All', 1, 3, 5, 10]"
                  dense
                  label="Choose Float Qnty %"
                  single
                  input-debounce="0"
                  class="ellipsis q-pl-sm"
                  :menu-absolute="true"
                  style="width: 135px"
                >
                  <q-tooltip> Float Qnty % greater than </q-tooltip>
                </q-select>
              </template>
              <template v-slot:top-right>
                <q-select
                  :menu-absolute="true"
                  bordered
                  class="ellipsis"
                  v-model.lazy="selectedBrokerDistribution"
                  single
                  dense
                  clearable
                  use-input
                  input-debounce="0"
                  :options="options"
                  option-value="broker_no"
                  option-label="broker_name"
                  emit-value
                  stack-label
                  map-options
                  label="Select broker Seller"
                  filter
                  @filter="filterFn"
                >
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps">
                      <q-item-section avatar>
                        <q-item-label class="text-bold">{{
                          scope.opt.broker_no
                        }}</q-item-label>
                      </q-item-section>
                      <q-item-section>
                        <q-item-label>
                          <div class="row">
                            {{ scope.opt.broker_name }}
                          </div>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>

                <q-checkbox
                  dense
                  class="q-pl-sm ellipsis"
                  v-model="mySignalsDistribution"
                  color="blue-5"
                  keep-color
                  label="My Signals"
                >
                  <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
                </q-checkbox>
              </template>
              <template v-slot:body-cell-symbol="props">
                <q-td :props="props">
                  <q-item
                    dense
                    clickable
                    :to="
                      !symbol && !isMainChart
                        ? {
                            path: '/stock-profile',
                            query: { symbol: props.value },
                          }
                        : ''
                    "
                    @click="onClickSymbolEmit(props.value)"
                  >
                    <div class="col">
                      {{ props.value }}
                      <q-tooltip>{{
                        allStocks.find((stock) => stock.symbol == props.value)
                          ?.name
                      }}</q-tooltip>
                    </div>
                  </q-item>
                </q-td>
              </template>
              <template v-slot:body-cell-seller="props">
                <q-td :props="props">
                  <div class="col">
                    {{ props.value }}
                    <q-tooltip>{{
                      brokerLists.find(
                        (broker) => broker.broker_no === props.value
                      )?.broker_name
                    }}</q-tooltip>
                  </div>
                </q-td>
              </template>
              <template v-slot:body-cell-qnty_percentage="props">
                <q-td :props="props">
                  <q-linear-progress
                    size="24px"
                    stripe
                    rounded
                    :value="props.value / 100"
                    color="red"
                  >
                    <div class="absolute-full flex flex-center">
                      <q-badge
                        color="white"
                        text-color="red"
                        :label="`${props.row.qnty_percentage?.toFixed(2)} %`"
                      />
                    </div>
                  </q-linear-progress>
                </q-td>
              </template>
            </q-table>
          </div>
        </q-card>
      </div>
    </template>
  </PackageAuth>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import useData from "src/use/data";
import useUtils from "src/use/utils";
import HelpComponent from "src/components/Help/HelpComponent.vue";
import PackageAuth from "../Packages/PackageAuth.vue";

const props = defineProps({
  symbol: {
    type: String,
    default: null,
  },
  isMainChart: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["chartSymbol"]);

const $q = useQuasar();
const { Accumulation, Distribution, brokerList } = useData();
const { amountConversion, utilsOptionSectors } = useUtils();
const store = useStore();
const timePeriodAccumulation = ref("OneDay");
const timePeriodDistribution = ref("OneDay");
const accumulationData = ref([]);
const distributionData = ref([]);
const brokerLists = ref([]);
const options = ref([]);
const selectedBrokerAccumulation = ref(null);
const selectedBrokerDistribution = ref(null);

const selectedQuantityAccumulation = ref("All");
const selectedQuantityDistribution = ref("All");

const allStocks = ref([]);
const mySignalsAccumulation = ref(false);
const mySignalsDistribution = ref(false);
const mySignalsStocks = ref([]);

const optionSectors = ref(utilsOptionSectors());
const selectedSectorAccumulation = ref(optionSectors.value[0]);
const selectedSectorDistribution = ref(optionSectors.value[0]);

const filterSymbolAccumulation = ref("");
const filterAccumulationData = (rows, terms, cols, getCellValue) => {
  return rows.filter((row) => {
    return row.symbol
      .toLowerCase()
      .includes(filterSymbolAccumulation.value.toLowerCase());
  });
};

const filterSymbolDistributation = ref("");
const filterDistributationData = (rows, terms, cols, getCellValue) => {
  return rows.filter((row) => {
    return row.symbol
      .toLowerCase()
      .includes(filterSymbolDistributation.value.toLowerCase());
  });
};

async function loadData(apiFunction, dataValue, days, symbol) {
  try {
    $q.loading.show({});
    let res;
    if (symbol) {
      res = await apiFunction(days, symbol);
    } else {
      res = await apiFunction(days);
    }
    dataValue.value = res.data.map((item) => {
      const sectorMatch = optionSectors.value.find(
        (sector) => sector.id === item.sector_id
      );

      const stockMatch = allStocks.value.find(
        (stock) => stock.symbol === item.symbol
      );

      const core_capital = stockMatch?.core_capital ?? 0;
      const public_shares = stockMatch?.public_shares ?? 0;

      // Calculate floated share
      const floated_share = (public_shares / 100) * core_capital;

      // Calculate qnty_percentage as of floated share
      const qnty_percentage = floated_share
        ? Math.abs(((item.tot_quantity / floated_share) * 100).toFixed(2))
        : 0;

      return {
        ...item,
        sector_name: sectorMatch ? sectorMatch.name : "Unknown Sector",
        qnty_percentage,
      };
    });
  } catch (error) {
    console.error(error);
  } finally {
    $q.loading.hide();
  }
}

function updateDataBasedOnTimePeriod(
  apiFunction,
  dataValue,
  timePeriodValue,
  days,
  symbol
) {
  if (
    [
      "OneDay",
      "TwoDay",
      "OneWeek",
      "TwoWeek",
      "OneMonth",
      "ThreeMonth",
      "SixMonth",
      "OneYear",
    ].includes(timePeriodValue)
  ) {
    loadData(apiFunction, dataValue, days, symbol);
  }
}

const computedaccumulationData = computed(() => {
  const sectorId = selectedSectorAccumulation.value.id;
  const buyerValue = selectedBrokerAccumulation.value;

  return accumulationData.value.filter((stock) => {
    const isSectorMatch = sectorId === 0 || stock.sector_id === sectorId;
    const isBuyerMatch = buyerValue === null || stock.buyer === buyerValue;
    const isQntyPercentage =
      selectedQuantityAccumulation.value === "All" ||
      stock.qnty_percentage >= selectedQuantityAccumulation.value;

    const isMySignalMatch =
      !mySignalsAccumulation.value ||
      mySignalsStocks.value.some((item) => item === stock.symbol);

    return isSectorMatch && isBuyerMatch && isQntyPercentage && isMySignalMatch;
  });
});

const computeddistributionData = computed(() => {
  const sectorId = selectedSectorDistribution.value.id;
  const sellerValue = selectedBrokerDistribution.value;

  return distributionData.value.filter((stock) => {
    const isSectorMatch = sectorId === 0 || stock.sector_id === sectorId;
    const isSellerMatch = sellerValue === null || stock.seller === sellerValue;

    const isQntyPercentage =
      selectedQuantityDistribution.value === "All" ||
      stock.qnty_percentage >= selectedQuantityDistribution.value;

    const isMySignalMatch =
      !mySignalsDistribution.value ||
      mySignalsStocks.value.some((item) => item === stock.symbol);

    return (
      isSectorMatch && isSellerMatch && isQntyPercentage && isMySignalMatch
    );
  });
});

const columns = [
  {
    name: "symbol",
    label: "Symbol",
    align: "left",
    field: "symbol",
    sortable: true,
  },
  // {
  //   name: "sector_name",
  //   label: "Sector",
  //   field: "sector_name",
  //   align: "center",
  //   sortable: true,
  // },
  {
    name: "tot_quantity",
    label: "Tot Qnt",
    align: "center",
    format: (val) => `${amountConversion(val)}`,
    field: "tot_quantity",
    sortable: true,
  },
  {
    name: "qnty_percentage",
    label: "Float Qnty %",
    align: "center",
    field: "qnty_percentage",
    sortable: true,
  },
  {
    name: "tot_amt",
    label: "Tot Amt",
    align: "center",
    format: (val) => `${amountConversion(val)}`,
    field: "tot_amt",
    sortable: true,
  },
  {
    name: "avg_rate",
    label: "Avg Rate",
    align: "center",
    format: (val, row) => `${(row.tot_amt / row.tot_quantity).toFixed(1)}`,
    sortable: true,
  },
  {
    name: "rn",
    label: "Rank",
    align: "center",
    field: "rn",
    sortable: true,
  },
];

const accumulationColumns = [
  ...columns.slice(0, 2),
  {
    name: "buyer",
    label: "Buyer",
    align: "center",
    field: "buyer",
  },
  ...columns.slice(2),
];

const distributionColumns = [
  ...columns.slice(0, 2),
  {
    name: "seller",
    label: "Seller",
    align: "center",
    field: "seller",
  },
  ...columns.slice(2),
];

const pagination = ref({
  rowsPerPage: 15,
  sortBy: "rn",
  descending: false,
});

watch(
  () => timePeriodAccumulation.value,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(
      Accumulation,
      accumulationData,
      newVal,
      {
        OneDay: 1,
        TwoDay: 2,
        OneWeek: 7,
        TwoWeek: 15,
        OneMonth: 30,
        ThreeMonth: 90,
        SixMonth: 180,
        OneYear: 365,
      }[newVal],
      props.symbol
    );
  }
);

watch(
  () => timePeriodDistribution.value,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(
      Distribution,
      distributionData,
      newVal,
      {
        OneDay: 1,
        TwoDay: 2,
        OneWeek: 7,
        TwoWeek: 15,
        OneMonth: 30,
        ThreeMonth: 90,
        SixMonth: 180,
        OneYear: 365,
      }[newVal],
      props.symbol
    );
  }
);

watch(
  () => props.symbol,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(
      Accumulation,
      accumulationData,
      timePeriodAccumulation.value,
      1,
      newVal
    );
    updateDataBasedOnTimePeriod(
      Distribution,
      distributionData,
      timePeriodDistribution.value,
      1,
      newVal
    );
  }
);

onMounted(async () => {
  allStocks.value = store.state.core.allStocks || [];
  if (!allStocks.value.length) {
    await store.dispatch("core/getAllStocks");
    allStocks.value = store.state.core.allStocks;
  }

  const currentPackage = store.state.packages.packageStatus;
  if (currentPackage.current_package.stocks.length) {
    mySignalsStocks.value = currentPackage.current_package.stocks;
  } else {
    await store.dispatch("packages/getPackageStatus");
    mySignalsStocks.value = currentPackage.current_package.stocks;
  }

  brokerLists.value = (await brokerList()).data;

  updateDataBasedOnTimePeriod(
    Accumulation,
    accumulationData,
    timePeriodAccumulation.value,
    1,
    props.symbol
  );
  updateDataBasedOnTimePeriod(
    Distribution,
    distributionData,
    timePeriodDistribution.value,
    1,
    props.symbol
  );
});

function filterFn(val, update) {
  if (val === "") {
    update(() => {
      options.value = brokerLists.value;
    });
    return;
  }

  update(() => {
    const needle = val;
    options.value = brokerLists.value.filter((v) => {
      return (
        v.broker_name.toLowerCase().indexOf(needle) > -1 ||
        v.broker_no.toString().toLowerCase().indexOf(needle) > -1
      );
    });
  });
}

const onClickSymbolEmit = (symbol) => {
  if (props.isMainChart) {
    emit("chartSymbol", symbol);
  }
};
</script>
